import { Search } from 'lucide-react'

/**
 * Airbnb-style collapsed search pill for mobile (< sm). A single rounded-full
 * bar showing either a placeholder ("Start your search") or a compact one-line
 * summary of the active query, with the same trailing brand-colored circular
 * search icon as the desktop (web) pill — themed per vertical via `brand`
 * tokens. Tapping it opens the full-screen {@link SearchSheet}. Presentational —
 * the parent owns state.
 */
export function MobileSearchPill({
  summary,
  placeholder = 'Start your search',
  onClick,
  ariaLabel = 'Open search',
}: {
  /** One-line summary of the active query; falsy shows the placeholder. */
  summary?: string
  placeholder?: string
  onClick: () => void
  ariaLabel?: string
}) {
  const active = Boolean(summary && summary.trim())
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="flex w-full items-center justify-between gap-3 rounded-full border border-stone-200 bg-white py-1.5 pl-6 pr-1.5 shadow-[0_3px_14px_rgba(28,25,23,0.10)] transition hover:shadow-[0_4px_20px_rgba(28,25,23,0.14)]"
    >
      <span
        className={`truncate text-sm font-semibold ${active ? 'text-stone-900' : 'text-stone-500'}`}
      >
        {active ? summary : placeholder}
      </span>
      <span
        aria-hidden="true"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-700 text-white"
      >
        <Search className="h-5 w-5" />
      </span>
    </button>
  )
}
